import { FilterType } from 'components/Shared/Table'
import {
  CONTRACTOR_ADDITIONAL_DATA_READ,
  CONTRACTOR_COST_PAYMENT_DUE_DATE_READ,
  CONTRACTOR_DATA_READ,
  CONTRACTOR_INCOME_PAYMENT_DUE_DATE_READ,
  CONTRACTOR_ROLES_READ,
} from 'context/auth'
import eInvoiceConsentOptions from 'constants/eInvoiceConsentOptions'
import contractorRolesOptions from 'constants/contractorRolesOptions'

export const createColumns = (hasAnyPrivileges, t) => {
  const contractorDataColumns = hasAnyPrivileges([CONTRACTOR_DATA_READ]) ? [{
    id: 'fullName',
    label: 'contractor.table.fullName',
    path: 'fullName',
    sortable: true,
    filterType: FilterType.Text
  },
    {
      id: 'shortName',
      label: 'contractor.table.shortName',
      path: 'shortName',
      sortable: true,
      filterType: FilterType.Text
    },
    {
      id: 'nipNumber',
      label: 'contractor.table.nipNumber',
      path: 'nipNumber',
      sortable: true,
      filterType: FilterType.Text
    },
    {
      id: 'regonNumber',
      label: 'contractor.table.regonNumber',
      path: 'regonNumber',
      sortable: true,
      filterType: FilterType.Text
    },
    {
      id: 'krsNumber',
      label: 'contractor.table.krsNumber',
      path: 'krsNumber',
      sortable: true,
      filterType: FilterType.Text
    }] : []

  const contractorAdditionalDataColumns = hasAnyPrivileges([CONTRACTOR_ADDITIONAL_DATA_READ]) ? [
    {
      id: 'eInvoiceConsent',
      label: 'contractor.table.eInvoiceConsent.title',
      path: 'eInvoiceConsent',
      selectOptions: eInvoiceConsentOptions,
      filterType: FilterType.Select
    },
    {
      id: 'additionalInfo',
      label: 'contractor.table.additionalInfo',
      path: 'additionalInfo',
      filterType: FilterType.Text
    }
  ] : []

  const contractorAdditionalDataIncomeColumns = hasAnyPrivileges([CONTRACTOR_ADDITIONAL_DATA_READ]) && hasAnyPrivileges([CONTRACTOR_INCOME_PAYMENT_DUE_DATE_READ]) ? [
    {
      id: 'incomePaymentDueDays',
      label: 'contractor.table.incomePaymentDueDays',
      path: 'incomePaymentDueDays',
      sortable: true,
      filterType: FilterType.Text
    }
  ] : []

  const contractorAdditionalDataCostColumns = hasAnyPrivileges([CONTRACTOR_ADDITIONAL_DATA_READ]) && hasAnyPrivileges([CONTRACTOR_COST_PAYMENT_DUE_DATE_READ]) ? [
    {
      id: 'costPaymentDueDays',
      label: 'contractor.table.costPaymentDueDays',
      path: 'costPaymentDueDays',
      sortable: true,
      filterType: FilterType.Text
    }
  ] : []

  const contractorRolesColumns = hasAnyPrivileges([CONTRACTOR_ROLES_READ]) ? [
    {
      id: 'roles',
      label: 'contractor.table.roles.title',
      path: 'roles',
      selectOptions: contractorRolesOptions,
      filterType: FilterType.Select,
      renderFunc: roles => roles.map(role => t(contractorRolesOptions.find(opt => opt.value === role).label)).join(', ')
    }
  ] : []

  return [
    ...contractorDataColumns,
    ...contractorAdditionalDataColumns,
    ...contractorAdditionalDataIncomeColumns,
    ...contractorAdditionalDataCostColumns,
    ...contractorRolesColumns
  ]
}
